import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Input,
  Modal,
  Typography,
  Divider,
  Tag,
  Space,
  Form,
  Alert,
  Card,
} from "antd";
import { ArrowLeftOutlined, ScanOutlined } from "@ant-design/icons";
import BarcodeScanner from "../../../Comman/Scanner/BarCodeScanner";

const { Text } = Typography;

const BinBulkScan = () => {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  const handleTagClick = () => {
    setError("");
    setIsModalOpen(true);
  };

  const handleSubmit = (values) => {
    const binId = values.binId?.trim();

    if (!binId) {
      setError("Please provide a valid scanned data or enter it manually");
      return;
    }

    try {
      setError("");
      setIsLoading(true);
      navigate(`/bulkscan?binId=${encodeURIComponent(binId)}`);
    } catch (error) {
      console.error(error);
      setError("An error occurred while processing the bin data");
      setIsLoading(false);
    }
  };

  const handleScan = (result) => {
    if (!result) {
      setError("No valid barcode detected. Please try again.");
      return;
    }

    setIsModalOpen(false);
    handleSubmit({ binId: result });
  };

  const handleScanError = (error) => {
    console.error(error);
    setError("Error accessing camera. Please try manual input or check camera permissions.");
  };

  return (
    <>
      <Card
        className="modern-card"
        title={
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <ScanOutlined />
            <Typography.Text strong>Bulk Bin Scanner</Typography.Text>
          </div>
        }
      >
        <div style={{ maxWidth: 420, margin: "0 auto" }}>
          {error && (
            <Alert
              message={error}
              type="error"
              showIcon
              style={{ marginBottom: 16, borderRadius: 10 }}
            />
          )}

          <div style={{ display: "flex", justifyContent: "center", marginBottom: 20 }}>
            <Tag
              onClick={handleTagClick}
              style={{
                width: "300px",
                height: "95px",
                color: "#fff",
                background: "linear-gradient(135deg, #1677ff, #4096ff)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                boxShadow: "0 8px 20px rgba(22, 119, 255, 0.20)",
                borderRadius: "14px",
                cursor: "pointer",
                border: "none",
              }}
            >
              <Space direction="vertical" align="center" size={2}>
                <ScanOutlined style={{ fontSize: 24, color: "#fff" }} />
                <Text strong style={{ fontSize: "18px", color: "white" }}>
                  SCAN HERE
                </Text>
              </Space>
            </Tag>
          </div>

          <Space
            size="large"
            style={{
              width: "100%",
              justifyContent: "center",
              padding: "4px 0 18px",
            }}
          >
            <Divider style={{ width: 100, margin: 0 }} />
            <Text strong type="secondary">
              OR
            </Text>
            <Divider style={{ width: 100, margin: 0 }} />
          </Space>

          <Form form={form} layout="vertical" onFinish={handleSubmit}>
            <Form.Item
              name="binId"
              label="Enter Bin ID Manually"
              rules={[
                {
                  required: true,
                  message: "Bin ID cannot be empty. Please provide a valid ID.",
                },
              ]}
            >
              <Input
                size="large"
                placeholder="Enter Bin ID"
                style={{
                  textAlign: "center",
                  borderRadius: 10,
                  height: 44,
                }}
              />
            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>
              <Space style={{ width: "100%", justifyContent: "space-between" }}>
                <Button
                  icon={<ArrowLeftOutlined />}
                  size="large"
                  onClick={() => navigate("/bulkscan")}
                  style={{ borderRadius: 10 }}
                >
                  Back
                </Button>

                <Button
                  size="large"
                  type="primary"
                  htmlType="submit"
                  loading={isLoading}
                  style={{
                    borderRadius: 10,
                    minWidth: 140,
                    fontWeight: 600,
                  }}
                >
                  Submit
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </div>
      </Card>

      <Modal
        title="Scan Bar Code"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        centered
      >
        <BarcodeScanner onScan={handleScan} onError={handleScanError} />
      </Modal>
    </>
  );
};

export default BinBulkScan;